import React, {Component} from 'react';
import {connect} from 'react-redux';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import {getCookie, CookieName} from '../utils/cookieManager';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Snackbar from '@material-ui/core/Snackbar';
import {resetStore} from '../actions/main';
import '../App.scss';

class Wallet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoadingPts: false,
      isLoadingHistory: false,
      isLoading: false,
      walletPoints: null,
      walletHistory: null,
    };

    this.fetchWalletPoints = this.fetchWalletPoints.bind(this);
    this.fetchWalletHistory = this.fetchWalletHistory.bind(this);
    this.initiateRefund = this.initiateRefund.bind(this);
    this.openSnackBar = this.openSnackBar.bind(this);
  }

  componentDidMount() {
    if (!getCookie(CookieName.USERTOKEN)) {
      this.props.reset();
    } else {
      this.fetchWalletPoints();
      this.fetchWalletHistory();
    }
  }

  componentWillUnmount = () => this.abortController.abort();
  abortController = new window.AbortController();

  openSnackBar = (message) => {
    const msg = (
      <div className="snackbar-msg" id="message-id">
        {message}
      </div>
    );
    this.setState({isSnackBarOpen: true, message: msg});
  };

  handleClose = () => {
    this.setState({isSnackBarOpen: false});
  };

  fetchWalletPoints() {
    this.setState({isLoadingPts: true});
    const token = getCookie(CookieName.USERTOKEN);
    const url = `https://securedapi.confirmtkt.com/api/platform/trainbooking/GetWalletPoints?userKey=${token}`;
    fetch(url, {signal: this.abortController.signal})
      .then((res) => res.json())
      .then((res) => {
        const twoDecimal = parseFloat(res.Points / 100).toFixed(2);
        this.setState({walletPoints: twoDecimal});
        this.setState({isLoadingPts: false});
      })
      .catch((error) => {
        if (error.name === 'AbortError') {
          console.error('Fetch aborted');
        } else {
          this.openSnackBar('Unable to get wallet points');
          console.error('Error:', error);
        }
      });
  }

  fetchWalletHistory() {
    this.setState({isLoadingHistory: true});
    const token = getCookie(CookieName.USERTOKEN);
    const url = `https://securedapi.confirmtkt.com/api/platform/trainbooking/getwallethistory?userKey=${token}&limit=50&position=0`;
    fetch(url, {signal: this.abortController.signal})
      .then((res) => res.json())
      .then((res) => {
        this.setState({walletHistory: res});
        this.setState({isLoadingHistory: false});
      })
      .catch((error) => {
        if (error.name === 'AbortError') {
          console.error('Fetch aborted');
        } else {
          this.openSnackBar('Something went wrong, Please try again later.');
          console.error('Error:', error);
        }
      });
  }

  initiateRefund() {
    this.setState({isLoading: true});
    const token = getCookie(CookieName.USERTOKEN);
    const url = `https://securedapi.confirmtkt.com/api/platform/trainbooking/initiateWalletRefund?userKey=${token}&limit=50&position=0`;
    fetch(url)
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          //show success msg
          this.openSnackBar(
            'We have successfully initiated your wallet refund request. Amount will be credited into your bank account withing 7 - 10 business days.'
          );
        } else {
          console.log(res.error);
          this.openSnackBar(res.error);
        }
      })
      .catch((error) => {
        this.openSnackBar('Something went wrong, Please try again later.');
        console.log(error);
      });
  }

  render() {
    const walletPtBlock = (
      <div className="wallet-pts">
        <div>
          {
            <span>
              ₹ <span className="point">{this.state.walletPoints}</span>
            </span>
          }
        </div>

        <div className="header-label">CONFIRMTKT WALLET BALANCE</div>

        <div
          className="tranfer-amount-btn"
          onClick={() => this.initiateRefund()}
        >
          TRANSFER WALLET AMOUNT TO BANK
        </div>
      </div>
    );

    const header = (
      <div className="header">
        <Grid container justifyContent="flex-start" className="from-to">
          {/* <Grid
            item
            xs={1}
            className="backBtn"
            onClick={() => {
              this.props.history.goBack();
            }}
          >
            <i className="material-icons">arrow_back</i>
          </Grid> */}
          <Grid item xs={12}>
            <div className="title">
              <span>Wallet Summary</span>
            </div>
          </Grid>
        </Grid>
      </div>
    );

    const walletHistoryBlock = (
      <div className="history">
        <div className="header-label">HISTORY</div>
        {this.state.walletHistory ? (
          this.state.walletHistory.map((wh, i) => (
            <Card className="historyCard" key={i}>
              <CardContent className="card-content">
                <Grid container justifyContent="flex-start">
                  <Grid item xs={9}>
                    <div>
                      {new Date(Date.parse(wh.dateTime)).toDateString()}
                    </div>
                    <div>TRANSACTION ID: {wh.transactionId}</div>
                  </Grid>
                  <Grid item xs={3} className="amount-container">
                    <div className={wh.amount > 0 ? 'credit' : 'debit'}>
                      {wh.amount > 0 ? 'CREDIT' : 'DEBIT'}
                    </div>
                    <div>₹ {wh.amount}</div>
                  </Grid>

                  <Grid item xs={12} className="summary">
                    {wh.transactionSummary}
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          ))
        ) : (
          <div />
        )}
      </div>
    );
    return (
      <div className="wallet-container">
        {header}
        <div className="content">
          {!this.state.isLoadingPts ? (
            walletPtBlock
          ) : (
            <div className="loading">
              <CircularProgress />
            </div>
          )}
          <hr />
          {!this.state.isLoadingHistory ? (
            walletHistoryBlock
          ) : (
            <div className="loading">
              <CircularProgress />
            </div>
          )}
        </div>

        <Snackbar
          anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
          open={this.state.isSnackBarOpen}
          onClose={this.handleClose}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          autoHideDuration={10000}
          message={this.state.message}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    reset: () => {
      dispatch(resetStore());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Wallet);
